import { put } from "@rails/request.js";
import Sortable from "sortablejs";
import ApplicationController from "./application_controller";

export default class extends ApplicationController {

    /*
     * Usage
     * =====
     *
     * add data-controller="sortable" to common ancestor
     *
     * 1. Add data-sortable-url-value="URL to update position" to the
     * controller container
     *
     * 2. Add data-sortable-handle to the drag handle:
     *
     * 3. Add data-sortable-id to the item
     *
     */

    static values = { url: String };

    connect() {
        this.sortable = Sortable.create(this.element, {
            onEnd: this.onEnd.bind(this),
            handle: "[data-sortable-handle]",
            animation: 150,
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            dragClass: 'sortable-drag',
            forceFallback: false,
            fallbackOnBody: true,
            swapThreshold: 0.65
        });
    }

    disconnect() {
        this.sortable.destroy();
    }

    /**
     * Stellt sicher, dass die URL absolut ist (Origin + Path).
     * Verhindert, dass der Request versehentlich an die aktuelle Resource-URL
     * (z. B. /backend/applicants/10248) geht statt an die Spalteneinstellungen-URL.
     */
    absoluteUrl(url) {
        if (!url || url === "#") return null;
        if (url.startsWith("http://") || url.startsWith("https://")) return url;
        const path = url.startsWith("/") ? url : `/${url}`;
        return `${window.location.origin}${path}`;
    }

    onEnd(event) {
        const { newIndex, item } = event;
        let url = this.urlValue || "";
        const id = item?.getAttribute("data-sortable-id");
        if (id != null && url.includes(":id")) {
            url = url.replace(":id", id);
        }
        url = this.absoluteUrl(url);
        if (!url) return;

        put(url, {
            body: JSON.stringify({ position: newIndex }),
            headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }
        });
    }

}